export default __webpack_public_path__ + "static/media/metamask-text.2f9c2df2.svg";